import {
  styled,
  flexAlignCenter,
  Theme,
  Colors,
  flexCenter,
} from '@unfold/theme';

export const FontItem = styled.div`
  ${flexAlignCenter}
  width: 100%;
  height: 50px;
  background-color: ${({ theme }): string =>
    theme?.name === Theme.LIGHT ? Colors.G600 : Colors.DG600};
  color: #3b3b3b;
  font-size: 14px;
  padding: 0 12px 0 20px;
  border-radius: 6px;
`;

export const FontNameContainer = styled.div`
  flex: 1;
  overflow: hidden;
`;

export const Divider = styled.div`
  width: 1px;
  height: 14px;
  background: ${({ theme }): string =>
    theme?.name === Theme.LIGHT ? Colors.G600 : Colors.DG600};
`;

export const PopoverContainer = styled.div`
  background-color: ${({ theme }): string =>
    theme?.name === Theme.LIGHT ? Colors.WHITE : Colors.G100};
  margin: 0px 10px;
  border-radius: 5px;
  box-shadow: 0 1px 30px rgba(0, 0, 0, 0.1);
  ${flexCenter}
`;
